export const StatusFilter = ({
  statuses,
  selectedStatus,
  onStatusChange,
}) => {
  if (!statuses.length) {
    return null;
  }

  return (
    <div className="filters">
      <div className="status-filter">
        {statuses.map(({ status, count }) => (
          <label
            key={status}
            className={`status-pill ${
              selectedStatus === status
                ? "status-active"
                : ""
            }`}
          >
            <input
              type="radio"
              name="status"
              value={status}
              checked={
                selectedStatus === status
              }
              onChange={(event) =>
                onStatusChange(
                  event.target.value
                )
              }
            />

            {status}

            <div
              className={`status-dot ${status}`}
            >
              {count}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};
